module.exports = __webpack_public_path__ + "assets/d5136fc0c7643308f5f14eb4d2e61134.png";